import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class PageNotFound extends Component {
  render() {
    return (
      <div className="d-flex flex-column mt-4">
        <div className="d-flex flex-row justify-content-center mb-4">
          <h1>404 Page not found</h1>
        </div>
        <div className="d-flex flex-row justify-content-center mb-4">
          <Link
            to="/"
            className="btn btn-primary"
            style={{ width: 100 }}
          >
            Home
          </Link>
        </div>
      </div>
    );
  }
}

export default PageNotFound;
